import { get4RaiseGroups } from '@/helpers/grouping'

const grouping_mix = {
  data() {
    return {}
  },
  methods: {
    setFilterActions(actions) {
      // if (!this.filterApplyAction) return
      // this.$store.dispatch(this.filterApplyAction, { key: 'actions', value: actions })
      this.$store.dispatch('sol_filters_apply', {
        key: 'actions',
        value: actions,
        applyFilterActionName: this.applyFilterActionName,
      })
    },
    toggleAction(action, active) {
      if (this.readOnly) {
        return
      }
      if (action.type === 'RAISE') {
        const actions = this.customSolution
        const raises = actions.filter(a => a.type === 'RAISE')
        if (raises.length > 1 && this.grouping !== 'swv_grouping_none') {
          if (this.grouping === 'swv_grouping_all') {
            const res = this.filterActions.filter(a => !raises.some(r => a.code === r.code))
            if (active) {
              this.setFilterActions(res)
            } else {
              this.setFilterActions([...res, ...raises])
            }
            return
          }
          if (this.grouping === 'swv_grouping_4') {
            const res = this.filterActions.filter(
              a => !action.grouped_actions.some(r => a.code === r.code),
            )
            if (active) {
              this.setFilterActions(res)
            } else {
              this.setFilterActions([...res, ...action.grouped_actions])
            }
            return
          }
        }
      }

      if (active) {
        this.setFilterActions(this.filterActions.filter(a => a.code !== action.code))
      } else {
        this.setFilterActions([...this.filterActions, action])
      }
    },
  },
  computed: {
    groupingSolution() {
      let actions = this.customSolution

      const raises = actions.filter(i => i.type === 'RAISE')
      if (raises.length > 1 && this.grouping !== 'swv_grouping_none') {
        const nonRaises = actions.filter(i => i.type !== 'RAISE')

        const getAddedValues = (a, b) => {
          const draw_categories = (b.draw_categories || []).map(i => {
            const aCategory = (a.draw_categories || []).find(c => c.name === i.name)
            const total_combos = i.total_combos + (aCategory?.total_combos || 0)
            return {
              ...i,
              total_combos,
            }
          })
          const hand_categories = (b.hand_categories || []).map(i => {
            const aCategory = (a.hand_categories || []).find(c => c.name === i.name)
            const total_combos = i.total_combos + (aCategory?.total_combos || 0)
            return {
              ...i,
              total_combos,
            }
          })

          const res = {
            draw_categories,
            hand_categories,
            [this.freKey]: (a?.[this.freKey] || 0) + b[this.freKey],
            total_combos: (a?.total_combos || 0) + b.total_combos,
            total_combos_default: (a?.total_combos_default || 0) + b.total_combos_default,
            group_display_name: b.raise_alias ? this.$t('moves.bet') : this.$t('moves.raise'),
            isNa: 'isNa' in a ? a.isNa && b.isNa : b.isNa, // custom reports only
          }
          return res
        }

        if (this.grouping === 'swv_grouping_all') {
          let raise = raises.reduce((a, b) => {
            const res = {
              ...a,
              ...b,
              ...getAddedValues(a, b),
              css_class: 'R',
            }
            return res
          }, {})

          const draw_categories = raise.draw_categories.map(i => {
            const total_occurrence = i.total_combos / (raise.total_combos_default || 1)
            return {
              ...i,
              total_occurrence,
            }
          })
          const hand_categories = raise.hand_categories.map(i => {
            const total_occurrence = i.total_combos / (raise.total_combos_default || 1)
            return {
              ...i,
              total_occurrence,
            }
          })

          raise = {
            ...raise,
            draw_categories,
            hand_categories,
          }

          raise.group_id = 'raise_all'
          raise.group_display_name = raise?.raise_alias ? 'bet_all' : 'raise_all'
          actions = [raise, ...nonRaises]

          const filterRaises = this.filterActions.filter(i => i.type === 'RAISE')
          raise.selected = filterRaises.length === raises.length
        }

        if (this.grouping === 'swv_grouping_4') {
          let raiseGroups = get4RaiseGroups({ raises, order: 'desc' })
          raiseGroups.forEach((raiseGroup, idx) => {
            raiseGroup.action = raiseGroup.actions.reduce((a, b) => {
              const res = {
                ...a,
                ...b,
                ...getAddedValues(a, b),
              }
              return res
            }, {})

            if (raiseGroup.actions.length) {
              const groupTotalCombos = raiseGroup.actions.reduce(
                (a, b) => a + b.total_combos_default,
                0,
              )

              const draw_categories = raiseGroup.action.draw_categories.map(i => {
                const total_occurrence = i.total_combos / (groupTotalCombos || 1)
                return {
                  ...i,
                  total_occurrence,
                }
              })
              const hand_categories = raiseGroup.action.hand_categories.map(i => {
                const total_occurrence = i.total_combos / (groupTotalCombos || 1)
                return {
                  ...i,
                  total_occurrence,
                }
              })

              raiseGroup.action = {
                ...raiseGroup.action,
                draw_categories,
                hand_categories,
              }
            }
          })
          raiseGroups = raiseGroups.filter(i => i.actions.length)

          const groupedRaises = raiseGroups.map((g, idx) => {
            const res = {
              ...g.action,
              group_id: g.id,
              group_display_name: g.group_display_name,
              grouped_actions: g.actions,
              css_class: g.css_class,
              selected: g.actions.every(fi => this.filterActions.some(r => r.code === fi.code)),
            }
            return res
          })

          actions = [groupedRaises, ...nonRaises].flat()
        }
      }

      // console.log(actions)
      // actions = [...actions, ...actions, ...actions, ...actions, ...actions, ...actions, ...actions]

      // actions = actions.filter((i, idx) => idx < 3)
      // actions = actions.filter((i, idx) => idx < 4)
      // actions = actions.filter((i, idx) => idx < 5)
      // actions = actions.filter((i, idx) => idx < 6)
      // actions = actions.filter((i,idx)=>idx<7)
      // actions = actions.filter((i, idx) => idx < 8)
      // actions = actions.filter((i, idx) => idx < 9)
      // actions = actions.filter((i, idx) => idx < 11)
      // actions = actions.filter((i, idx) => idx < 12)
      // actions = actions.filter((i,idx)=>idx<13)
      // actions = actions.filter((i,idx)=>idx<14)
      // actions = actions.filter((i,idx)=>idx<15)
      // actions = actions.filter((i, idx) => idx < 16)
      // actions = actions.filter((i,idx)=>idx<17)
      // actions = actions.filter((i, idx) => idx < 18)
      // actions = actions.filter((i,idx)=>idx<19)
      // actions = actions.filter((i,idx)=>idx<20)
      // actions = actions.filter((i, idx) => idx < 21)
      // actions = actions.filter((i,idx)=>idx<22)
      // actions = actions.filter((i, idx) => idx < 23)
      // actions = actions.filter((i, idx) => idx < 24)
      // console.log(actions)
      return actions
    },
  },
}

export default grouping_mix
